// ── Regra da Ana (28/09/2026): cliente sem resposta há 15 horas ou mais ──────
// Conta 15 horas corridas desde a última mensagem do cliente. O gerente vê
// esses casos no topo do Meu Dia; o consultor vê a marca "+15h" no item.
export const HORAS_ALERTA = 15;
const LIMITE_MS = HORAS_ALERTA * 60 * 60 * 1000;

export function passou15h(waitingAt, agora = Date.now()) {
  return Number.isFinite(waitingAt) && waitingAt > 0 && agora - waitingAt >= LIMITE_MS;
}

export function alertaSemResposta(itens, agora = Date.now()) {
  return (Array.isArray(itens) ? itens : [])
    .filter(item => passou15h(item?.waitingAt, agora))
    .sort((a, b) => a.waitingAt - b.waitingAt);
}
